import React, { useState, useEffect, useMemo } from 'react';
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import * as XLSX from 'xlsx';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import { useLocation } from 'react-router-dom';
import { formatReadableAmount } from '../../../../Common/FormatFunctions/FormatAmount';
import { RingLoader } from 'react-spinners';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography, TableFooter } from "@mui/material";
import PdfPreview from '../../../../Common/PdfPreview_Default';

const apikey = process.env.REACT_APP_API;

const HamaliTolaiReport = () => {
    const location = useLocation();
    const Company_Name = sessionStorage.getItem('Company_Name')
    const Company_GSTNO = sessionStorage.getItem('Company_GSTNO')
    const searchParams = new URLSearchParams(location.search);
    const fromDate = searchParams.get('fromDate');
    const toDate = searchParams.get('toDate');
    const company_Code = searchParams.get('Company_Code');
    const Year_Code = searchParams.get('Year_Code');
    const Broker_code = searchParams.get('Broker_code');
    const [pdfPreview, setPdfPreview] = useState(null);

    const [reportData, setReportData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const [grandTotals, setGrandTotals] = useState({
        Bill_Amount: 0,
        Market_Cess: 0,
        Tolaical: 0,
        hamalical: 0,   // Sale Hamali
        Hamaliamt: 0,   // Patti Hamali
        Commission: 0,
        Payable: 0
    });

    const API_URL = `${apikey}/generating_haladsaleBill_report_forhamalitolai`;

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = String(date.getFullYear());
        return `${day}/${month}/${year}`;
    };


    const uniqueReportData = useMemo(() => {
        const seen = new Map();
        reportData.forEach((item) => {
            const key = item.GullHeadDocNo; // change if bill no. isn't unique alone, e.g. `${item.GullHeadDocNo}_${item.doc_date}`
            if (!seen.has(key)) {
                seen.set(key, item);
            }
        });
        return Array.from(seen.values());
    }, [reportData]);


    useEffect(() => {
        if (uniqueReportData.length > 0) {
            const totals = uniqueReportData.reduce(
                (acc, item) => {
                    const billAmount = Number(item.Bill_Amount) || 0;
                    const tdsAmt = Number(item.Tds_Amt) || 0;
                    acc.Bill_Amount += billAmount;
                    acc.Market_Cess += Number(item.Market_Cess) || 0;
                    acc.Tolaical += Number(item.Tolaical) || 0;
                    acc.hamalical += Number(item.hamalical) || 0;
                    acc.Hamaliamt += Number(item.Hamaliamt) || 0;
                    acc.Commission += Number(item.Commission) || 0;
                    acc.Payable += (billAmount - tdsAmt);
                    return acc;
                },
                { Bill_Amount: 0, Market_Cess: 0, Tolaical: 0, hamalical: 0, Hamaliamt: 0, Commission: 0, Payable: 0 }
            );
            setGrandTotals(totals);
        } else {
            setGrandTotals({
                Bill_Amount: 0, Market_Cess: 0, Tolaical: 0,
                hamalical: 0, Hamaliamt: 0, Commission: 0, Payable: 0
            });
        }
    }, [uniqueReportData]);

    useEffect(() => {
        const fetchReportData = async () => {
            setLoading(true);
            setError('');
            try {
                const response = await axios.get(API_URL, {
                    params: {
                        from_date: fromDate,
                        to_date: toDate,
                        Company_Code: company_Code,
                        Year_Code: Year_Code,
                        // Broker_code: Broker_code
                    },
                });
                setReportData(response.data.all_data || []);
            } catch (error) {
                console.error('Error fetching report:', error);
                setError('Error fetching report');
                setReportData([]);
            } finally {
                setLoading(false);
            }
        };

        fetchReportData();
    }, [API_URL]);

    useEffect(() => {
        if (reportData.length > 0) {
            const totals = reportData.reduce(
                (acc, item) => {
                    const billAmount = Number(item.Bill_Amount) || 0;
                    const tdsAmt = Number(item.Tds_Amt) || 0; // <-- adjust field name if different
                    acc.Bill_Amount += billAmount;
                    acc.Market_Cess += Number(item.Market_Cess) || 0;
                    acc.Tolaical += Number(item.Tolaical) || 0;
                    acc.hamalical += Number(item.hamalical) || 0;
                    acc.Hamaliamt += Number(item.Hamaliamt) || 0;
                    acc.Commission += Number(item.Commission) || 0;
                    acc.Payable += (billAmount - tdsAmt);
                    return acc;
                },
                { Bill_Amount: 0, Market_Cess: 0, Tolaical: 0, hamalical: 0, Hamaliamt: 0, Commission: 0, Payable: 0 }
            );

            setGrandTotals(totals);
        } else {
            setGrandTotals({
                Bill_Amount: 0,
                Market_Cess: 0,
                Tolaical: 0,
                hamalical: 0,
                Hamaliamt: 0,
                Commission: 0,
                Payable: 0
            });
        }
    }, [reportData]);

    const handleExportToExcel = () => {
        const wb = XLSX.utils.book_new();
        const headers = [
            "Bill No", "Doc Date", "Party Name", "Bill Amount", "Market Cess",
            "Tolai", "Sale Hamali", "Patti Hamali", "Commission", "Payable"
        ];

        const formattedData = uniqueReportData.map(item => {
            const billAmount = Number(item.Bill_Amount) || 0;
            const tdsAmt = Number(item.Tds_Amt) || 0;
            return {
                "Bill No": item.GullHeadDocNo,
                "Doc Date": formatDate(item.doc_date),
                "Party Name": item.GulSaleBillAccName,
                "Bill Amount": billAmount,
                "Market Cess": Number(item.Market_Cess) || 0,
                "Tolai": Number(item.Tolaical) || 0,
                "Sale Hamali": Number(item.hamalical) || 0,
                "Patti Hamali": Number(item.Hamaliamt) || 0,
                "Commission": Number(item.Commission) || 0,
                "Payable": billAmount - tdsAmt,
            };
        });

        // Total row
        formattedData.push({
            "Bill No": "",
            "Doc Date": "",
            "Party Name": "Total",
            "Bill Amount": grandTotals.Bill_Amount,
            "Market Cess": grandTotals.Market_Cess,
            "Tolai": grandTotals.Tolaical,
            "Sale Hamali": grandTotals.hamalical,
            "Patti Hamali": grandTotals.Hamaliamt,
            "Commission": grandTotals.Commission,
            "Payable": grandTotals.Payable,
        });

        const ws = XLSX.utils.json_to_sheet(formattedData, { header: headers });
        ws["!cols"] = [
            { wch: 12 }, { wch: 14 }, { wch: 28 }, { wch: 14 }, { wch: 14 },
            { wch: 12 }, { wch: 14 }, { wch: 14 }, { wch: 14 }, { wch: 14 },
        ];
        XLSX.utils.book_append_sheet(wb, ws, 'HamaliTolaiReport');
        XLSX.writeFile(wb, 'HamaliTolaiReport.xlsx');
    };



    const handlePrint = () => {
        const companyName = Company_Name;
        const fromDateParam = searchParams.get('fromDate');
        const toDateParam = searchParams.get('toDate');

        const doc = generatePDFDocument(companyName,);
        const pdfUrl = URL.createObjectURL(doc);
        const printWindow = window.open(pdfUrl);
        printWindow.onload = function () {
            setTimeout(() => {
                printWindow.print();
            }, 500);
        };
    };

    const generatePDFDocument = (companyName) => {
        const doc = new jsPDF();

        doc.setFontSize(12);
        doc.setFont(undefined, 'bold');
        doc.text(companyName, doc.internal.pageSize.width / 2, 15, { align: 'center' });

        doc.setFontSize(10);
        doc.setFont(undefined, 'normal');
        doc.text(`GSTN : ${Company_GSTNO}`, doc.internal.pageSize.width / 2, 23, { align: 'center' });

        doc.setFontSize(12);
        doc.setFont(undefined, 'bold');
        doc.text("Report", doc.internal.pageSize.width / 2, 32, { align: 'center' });

        const startY = 40;

        const head = [[
            "Bill No", "Doc Date", "Party Name", "Bill Amount", "Market Cess",
            "Tolai", "Sale Hamali", "Patti Hamali", "Commission", "Payable"
        ]];

        const body = uniqueReportData.map(item => {
            const billAmount = Number(item.Bill_Amount) || 0;
            const tdsAmt = Number(item.Tds_Amt) || 0;
            return [
                item.GullHeadDocNo,
                formatDate(item.doc_date),
                item.GulSaleBillAccName,
                formatReadableAmount(billAmount),
                formatReadableAmount(item.Market_Cess),
                formatReadableAmount(item.Tolaical),
                formatReadableAmount(item.hamalical),
                formatReadableAmount(item.Hamaliamt),
                formatReadableAmount(item.Commission),
                formatReadableAmount(billAmount - tdsAmt),
            ];
        });

        const foot = [[
            "", "", "Total",
            formatReadableAmount(grandTotals.Bill_Amount),
            formatReadableAmount(grandTotals.Market_Cess),
            formatReadableAmount(grandTotals.Tolaical),
            formatReadableAmount(grandTotals.hamalical),
            formatReadableAmount(grandTotals.Hamaliamt),
            formatReadableAmount(grandTotals.Commission),
            formatReadableAmount(grandTotals.Payable),
        ]];

        doc.autoTable({
            head,
            body,
            foot,
            startY,
            styles: {
                fontSize: 7,
                cellPadding: { top: 1, bottom: 1, left: 1.5, right: 1.5 },
            },
            headStyles: {
                fillColor: [255, 0, 0],
                textColor: [255, 255, 255],
                fontStyle: 'bold',
                halign: 'center',
            },
            footStyles: {
                fillColor: [255, 255, 0],
                textColor: [0, 0, 0],
                fontStyle: 'bold',
            },
            columnStyles: {
                0: { halign: 'left' },
                1: { halign: 'center' },
                2: { halign: 'left' },
                3: { halign: 'right' },
                4: { halign: 'right' },
                5: { halign: 'right' },
                6: { halign: 'right' },
                7: { halign: 'right' },
                8: { halign: 'right' },
                9: { halign: 'right' },
            },
            margin: { top: startY },
        });

        const pdfBlob = doc.output('blob');
        const pdfUrl = URL.createObjectURL(pdfBlob);
        setPdfPreview(pdfUrl);
        return pdfBlob;
    };



    const groupReportData = (all_data) => {
        const groupedData = {};
        if (!Array.isArray(all_data)) {
            return groupedData;
        }
        all_data.forEach((item) => {
            const key = `${item.GullHeadDocNo}`;
            if (!groupedData[key]) {
                groupedData[key] = {
                    items: [],
                    totalQty: 0,
                };
            }
            groupedData[key].items.push(item);
        });
        return groupedData;
    };

    const groupedReportData = groupReportData(reportData);

    const safeAmount = (val) => {
        const num = Number(val);
        return isFinite(num) ? num : 0;
    };


    return (
        <div style={{ marginTop: "10px" }}>
            <Typography variant="h6" style={{ textAlign: 'center', fontSize: "24px", fontWeight: "bold" }}>{Company_Name}</Typography>
            <Typography variant="h6" style={{ textAlign: 'center', fontSize: "16px", textDecoration: 'underline', fontWeight: "550" }}>GSTN : {Company_GSTNO}</Typography>
            <Typography variant="h6" style={{ textAlign: 'center', fontSize: "20px", fontWeight: "bold" }}>Report</Typography>
            {/* <Typography variant="h6" style={{ textAlign: 'center', fontSize: "16px" }}>{fromDate ? FormaDateBalanceSheet(fromDate) : ""} to {toDate ? FormaDateBalanceSheet(toDate) : ""}</Typography> */}

            <div className="mb-3 row align-items-center">
                <div className="col-auto">
                    <button className="btn btn-secondary me-2" onClick={handlePrint}>
                        Print
                    </button>
                    <button className="btn btn-success" onClick={handleExportToExcel}>
                        Export to Excel
                    </button>
                    <button className="btn btn-secondary me-2" onClick={() => generatePDFDocument(Company_Name,)}>
                        Preview PDF
                    </button>
                    {pdfPreview && (
                        <PdfPreview
                            pdfData={pdfPreview}
                            apiData={reportData[0]}
                            label={"SaleRegister"}
                        />
                    )}
                </div>
            </div>

            <div style={{
                maxHeight: 'calc(100vh - 200px)',
                overflow: 'auto',
                position: 'relative',
                border: '1px solid #e0e0e0',
                marginBottom: '60px'
            }} id="reportTable">
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                    <TableHead sx={{
                        position: 'sticky',
                        top: 0,
                        zIndex: 1,
                        backgroundColor: 'white'
                    }}>
                        <TableRow>
                            <TableCell style={{ textAlign: "center", fontWeight: "bold", backgroundColor: 'white' }}>Bill No</TableCell>
                            <TableCell style={{ textAlign: "left", fontWeight: "bold", backgroundColor: 'white' }}>Doc Date</TableCell>

                            <TableCell style={{ textAlign: "center", fontWeight: "bold", backgroundColor: 'white' }}>Party Name</TableCell>
                            <TableCell style={{ textAlign: "center", fontWeight: "bold", backgroundColor: 'white' }}>Bill Amount</TableCell>
                            <TableCell style={{ textAlign: "center", fontWeight: "bold", backgroundColor: 'white' }}>Market Cess</TableCell>
                            <TableCell style={{ textAlign: "center", fontWeight: "bold", backgroundColor: 'white' }}>Tolai</TableCell>
                            <TableCell style={{ textAlign: "center", fontWeight: "bold", backgroundColor: 'white' }}>Sale Hamali</TableCell>
                            <TableCell style={{ textAlign: "center", fontWeight: "bold", backgroundColor: 'white' }}>Patti Hamali</TableCell>
                            <TableCell style={{ textAlign: "center", fontWeight: "bold", backgroundColor: 'white' }}>Commission</TableCell>
                            <TableCell style={{ textAlign: "center", fontWeight: "bold", backgroundColor: 'white' }}>Payable</TableCell>
                        </TableRow>
                    </TableHead>


                    <TableBody>
                        {Array.isArray(uniqueReportData) && uniqueReportData.map((item, idx) => {
                            const billAmount = Number(item.Bill_Amount) || 0;
                            const tdsAmt = Number(item.Tds_Amt) || 0;
                            const payable = billAmount - tdsAmt;

                            return (
                                <TableRow key={idx} sx={{ cursor: "pointer", "&:hover": { backgroundColor: "#fdfd96" } }}>
                                    <TableCell>{item.GullHeadDocNo}</TableCell>
                                    <TableCell style={{ textAlign: "center" }}>{formatDate(item.doc_date)}</TableCell>
                                    <TableCell style={{ textAlign: "center" }}>{item.GulSaleBillAccName}</TableCell>
                                    <TableCell style={{ textAlign: "right" }}>{formatReadableAmount(billAmount)}</TableCell>
                                    <TableCell style={{ textAlign: "right" }}>{formatReadableAmount(item.Market_Cess)}</TableCell>
                                    <TableCell style={{ textAlign: "right" }}>{formatReadableAmount(item.Tolaical)}</TableCell>
                                    <TableCell style={{ textAlign: "right" }}>{formatReadableAmount(item.hamalical)}</TableCell>
                                    <TableCell style={{ textAlign: "right" }}>{formatReadableAmount(item.Hamaliamt)}</TableCell>
                                    <TableCell style={{ textAlign: "right" }}>{formatReadableAmount(item.Commission)}</TableCell>
                                    <TableCell style={{ textAlign: "right" }}>{formatReadableAmount(payable)}</TableCell>
                                </TableRow>
                            );
                        })}

                        {/* Grand total row */}
                        <TableRow sx={{ backgroundColor: '#ffff99', fontWeight: 'bold' }}>
                            <TableCell colSpan={3} style={{ textAlign: 'right', fontWeight: 'bold' }}>Total: </TableCell>
                            <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>{formatReadableAmount(grandTotals.Bill_Amount)}</TableCell>
                            <TableCell style={{ textAlign: 'right', fontWeight: 'bold' }}>{formatReadableAmount(grandTotals.Market_Cess)}</TableCell>
                            <TableCell style={{ textAlign: 'right', fontWeight: 'bold' }}>{formatReadableAmount(grandTotals.Tolaical)}</TableCell>
                            <TableCell style={{ textAlign: 'right', fontWeight: 'bold' }}>{formatReadableAmount(grandTotals.hamalical)}</TableCell>
                            <TableCell style={{ textAlign: 'right', fontWeight: 'bold' }}>{formatReadableAmount(grandTotals.Hamaliamt)}</TableCell>
                            <TableCell style={{ textAlign: 'right', fontWeight: 'bold' }}>{formatReadableAmount(grandTotals.Commission)}</TableCell>
                            <TableCell style={{ textAlign: 'right', fontWeight: 'bold' }}>{formatReadableAmount(grandTotals.Payable)}</TableCell>
                        </TableRow>
                    </TableBody>


                </Table>
            </div>

            {loading && (
                <div style={{
                    position: 'fixed',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    zIndex: 9999
                }}>
                    <RingLoader size={80} />
                </div>
            )}
            {error && <div className="alert alert-danger">{error}</div>}
        </div>
    );
};

export default HamaliTolaiReport;
